import { Route } from 'react-router-dom';
import IsOwnerAuth from './IsOwnerAuth';
import ManageUsers from '../../ManageUsers/ManageUsers';
// import ManageUsers from '../../ManageUsers/ManageUsers';

const useIsOwnerRouter = (): JSX.Element => {
  return (
    <>
      <Route path="owner" element={<IsOwnerAuth />} >
        {/* Manage Users */}
        <Route path="manageUsers" element={<ManageUsers />} />
        {/* /Manage Users */}

        <Route path="*" element={<div>404 Not Found</div>} />
      </Route>
    </>
  );
};

export default useIsOwnerRouter;
